/* components/Quiz1.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	add_flush_callback,
	add_render_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_bidirectional_transition,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	globals,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	prevent_default,
	safe_not_equal,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

const { Boolean: Boolean_1 } = globals;
import { fade } from "svelte/transition";
import store from "../store";
import Radio from "./Radio.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-1ez54dj-style";
	style.textContent = ".subtitle.svelte-1ez54dj{margin-bottom:24px}.error.svelte-1ez54dj{color:#FF4A4A}button.svelte-1ez54dj:disabled{opacity:0.2}@media(min-width: 768px){.subtitle.svelte-1ez54dj{margin-bottom:35px}}";
	append(document.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

// (53:8) {:else}
function create_else_block_2(ctx) {
	let div;
	let div_transition;
	let current;

	return {
		c() {
			div = element("div");

			div.innerHTML = `<img class="quiz__image-mobile" src="https://s3.cointelegraph.com/storage/uploads/view/220b818d4c8f5f2e304c3806d761e416.png" alt="What can a NFT represent?"> 
            <img class="quiz__image-desktop" src="https://s3.cointelegraph.com/storage/uploads/view/120a80f78a25cebd6241fa50e74e4d2e.png" alt="What can a NFT represent?">`;

			attr(div, "class", "quiz__image-wrap");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			current = true;
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching && div_transition) div_transition.end();
		}
	};
}

// (40:8) {#if isQuizPassed}
function create_if_block_2(ctx) {
	let div;
	let div_transition;
	let current;

	return {
		c() {
			div = element("div");

			div.innerHTML = `<img class="quiz__image-mobile" src="https://s3.cointelegraph.com/storage/uploads/view/2f97d2f52caf08c63bedaeef3ab817f4.png" alt="What can a NFT represent?"> 
            <img class="quiz__image-desktop" src="https://s3.cointelegraph.com/storage/uploads/view/98f5136850d1d587e13590bd0e26b829.png" alt="What can a NFT represent?">`;

			attr(div, "class", "quiz__image-wrap");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			current = true;
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching && div_transition) div_transition.end();
		}
	};
}

// (86:6) {:else}
function create_else_block_1(ctx) {
	let form;
	let h3;
	let t1;
	let t2;
	let button;
	let t3;
	let button_disabled_value;
	let current;
	let mounted;
	let dispose;
	let each_value = /*list*/ ctx[3];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			form = element("form");
			h3 = element("h3");
			h3.textContent = "What can a NFT represent?";
			t1 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			button = element("button");
			t3 = text("answer");
			attr(h3, "class", "subtitle svelte-1ez54dj");
			attr(button, "class", "button svelte-1ez54dj");
			button.disabled = button_disabled_value = !/*group*/ ctx[0];
		},
		m(target, anchor) {
			insert(target, form, anchor);
			append(form, h3);
			append(form, t1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(form, null);
			}

			append(form, t2);
			append(form, button);
			append(button, t3);
			current = true;

			if (!mounted) {
				dispose = listen(form, "submit", prevent_default(/*submit_handler*/ ctx[5]));
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*list, group*/ 9) {
				each_value = /*list*/ ctx[3];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(form, t2);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (!current || dirty & /*group*/ 1 && button_disabled_value !== (button_disabled_value = !/*group*/ ctx[0])) {
				button.disabled = button_disabled_value;
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean_1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(form);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

// (73:6) {#if isQuizPassed}
function create_if_block(ctx) {
	let h3;
	let t0;
	let div;

	function select_block_type_2(ctx, dirty) {
		if (/*isCorrectAnswer*/ ctx[1]) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type_2(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			h3 = element("h3");
			if_block.c();
			t0 = space();
			div = element("div");
			div.textContent = "NFTs can be used to represent all of these things… and much, much more. They have the\n          potential to modernize the lucrative collectibles market, eliminate fraud in the\n          entertainment industry, open up new possibilities in gaming, and allow someone to own a\n          real-world asset that’s thousands of miles away.";
			attr(h3, "class", "subtitle svelte-1ez54dj");
			toggle_class(h3, "error", !/*isCorrectAnswer*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, h3, anchor);
			if_block.m(h3, null);
			insert(target, t0, anchor);
			insert(target, div, anchor);
		},
		p(ctx, dirty) {
			if (current_block_type !== (current_block_type = select_block_type_2(ctx, dirty))) {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(h3, null);
				}
			}

			if (dirty & /*isCorrectAnswer*/ 2) {
				toggle_class(h3, "error", !/*isCorrectAnswer*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h3);
			if_block.d();
			if (detaching) detach(t0);
			if (detaching) detach(div);
		}
	};
}

// (90:12) <Radio bind:group value={item}>
function create_default_slot(ctx) {
	let span;
	let t_value = /*item*/ ctx[8] + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (89:10) {#each list as item}
function create_each_block(ctx) {
	let radio;
	let updating_group;
	let current;

	function radio_group_binding(value) {
		/*radio_group_binding*/ ctx[4].call(null, value);
	}

	let radio_props = {
		value: /*item*/ ctx[8],
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	if (/*group*/ ctx[0] !== void 0) {
		radio_props.group = /*group*/ ctx[0];
	}

	radio = new Radio({ props: radio_props });
	binding_callbacks.push(() => bind(radio, "group", radio_group_binding));

	return {
		c() {
			create_component(radio.$$.fragment);
		},
		m(target, anchor) {
			mount_component(radio, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const radio_changes = {};

			if (dirty & /*$$scope*/ 2048) {
				radio_changes.$$scope = { dirty, ctx };
			}

			if (!updating_group && dirty & /*group*/ 1) {
				updating_group = true;
				radio_changes.group = /*group*/ ctx[0];
				add_flush_callback(() => updating_group = false);
			}

			radio.$set(radio_changes);
		},
		i(local) {
			if (current) return;
			transition_in(radio.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(radio.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(radio, detaching);
		}
	};
}

// (77:10) {:else}
function create_else_block(ctx) {
	let t;

	return {
		c() {
			t = text("Not Quite...");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (75:10) {#if isCorrectAnswer}
function create_if_block_1(ctx) {
	let t;

	return {
		c() {
			t = text("That’s right!");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let div5;
	let div2;
	let div1;
	let div0;
	let current_block_type_index;
	let if_block0;
	let div0_transition;
	let t;
	let div4;
	let div3;
	let current_block_type_index_1;
	let if_block1;
	let current;
	const if_block_creators = [create_if_block_2, create_else_block_2];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*isQuizPassed*/ ctx[2]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	const if_block_creators_1 = [create_if_block, create_else_block_1];
	const if_blocks_1 = [];

	function select_block_type_1(ctx, dirty) {
		if (/*isQuizPassed*/ ctx[2]) return 0;
		return 1;
	}

	current_block_type_index_1 = select_block_type_1(ctx, -1);
	if_block1 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);

	return {
		c() {
			div5 = element("div");
			div2 = element("div");
			div1 = element("div");
			div0 = element("div");
			if_block0.c();
			t = space();
			div4 = element("div");
			div3 = element("div");
			if_block1.c();
			attr(div0, "class", "quiz__wrap");
			attr(div1, "class", "card quiz__img svelte-1ez54dj");
			attr(div2, "class", "quiz__block");
			attr(div3, "class", "card quiz__info");
			attr(div4, "class", "quiz__block");
			attr(div5, "class", "quiz__row");
		},
		m(target, anchor) {
			insert(target, div5, anchor);
			append(div5, div2);
			append(div2, div1);
			append(div1, div0);
			if_blocks[current_block_type_index].m(div0, null);
			append(div5, t);
			append(div5, div4);
			append(div4, div3);
			if_blocks_1[current_block_type_index_1].m(div3, null);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index !== previous_block_index) {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				}

				transition_in(if_block0, 1);
				if_block0.m(div0, null);
			}

			let previous_block_index_1 = current_block_type_index_1;
			current_block_type_index_1 = select_block_type_1(ctx, dirty);

			if (current_block_type_index_1 === previous_block_index_1) {
				if_blocks_1[current_block_type_index_1].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks_1[previous_block_index_1], 1, 1, () => {
					if_blocks_1[previous_block_index_1] = null;
				});

				check_outros();
				if_block1 = if_blocks_1[current_block_type_index_1];

				if (!if_block1) {
					if_block1 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
					if_block1.c();
				}

				transition_in(if_block1, 1);
				if_block1.m(div3, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);

			add_render_callback(() => {
				if (!div0_transition) div0_transition = create_bidirectional_transition(div0, fade, {}, true);
				div0_transition.run(1);
			});

			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			if (!div0_transition) div0_transition = create_bidirectional_transition(div0, fade, {}, false);
			div0_transition.run(0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div5);
			if_blocks[current_block_type_index].d();
			if (detaching && div0_transition) div0_transition.end();
			if_blocks_1[current_block_type_index_1].d();
		}
	};
}

let answer = "All of the above";

function instance($$self, $$props, $$invalidate) {
	let group;
	let result;
	let isCorrectAnswer;
	let isQuizPassed = false;
	let successfullyCompleted;

	let list = [
		"Crypto collectibles",
		"Digital artwork",
		"A ticket to an event",
		"An in-game item",
		"An item in a virtual universe",
		"A real-world asset",
		"All of the above"
	];

	function radio_group_binding(value) {
		group = value;
		$$invalidate(0, group);
	}

	const submit_handler = () => $$invalidate(2, isQuizPassed = true);

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*group*/ 1) {
			$: $$invalidate(1, isCorrectAnswer = group === answer);
		}

		if ($$self.$$.dirty & /*isCorrectAnswer*/ 2) {
			$: result = isCorrectAnswer ? "That’s right!" : "Not Quite...";
		}

		if ($$self.$$.dirty & /*isQuizPassed, isCorrectAnswer*/ 6) {
			$: $$invalidate(7, successfullyCompleted = Boolean(isQuizPassed && isCorrectAnswer));
		}

		if ($$self.$$.dirty & /*successfullyCompleted*/ 128) {
			$: {
				store.update(storeValues => ({
					...storeValues,
					hasQuiz1SuccessAnswer: successfullyCompleted
				}));
			}
		}
	};

	return [
		group,
		isCorrectAnswer,
		isQuizPassed,
		list,
		radio_group_binding,
		submit_handler
	];
}

class Quiz1 extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1ez54dj-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Quiz1;